export default __webpack_public_path__ + "static/media/icon-file-pdf.d0b78012.svg";